import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=648171fd&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/dropfile.css?vue&type=style&index=0&id=648171fd&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648171fd",
  null
  
)

export default component.exports